<template>
  <div class="container fade-in">
    <div class="min-vh-100 d-flex justify-content-center align-content-center">
      <div class="m-auto col-lg-8">
        <div class="card-group">
          <div class="card p-4">
            <div class="card-body">
              <div v-if="loading" class="loading-container">
                <RotateSquare
                  class="loading-position animated fadeIn"
                  size="60px"
                ></RotateSquare>
              </div>
              <form
                v-else-if="step === 'conta'"
                key="form-conta"
                @submit="onContaValidate"
              >
                <h1>Selecione a conta</h1>
                <p class="text-muted">
                  O e-mail <strong>{{ email }}</strong> está vinculado a mais de
                  uma conta.
                </p>
                <div class="d-flex flex-column">
                  <b-form-radio
                    v-for="conta in contas"
                    :key="conta.id"
                    v-model="contaId"
                    :value="conta.id"
                    name="conta"
                    class="mb-3"
                  >
                    <span class="d-block font-weight-bold">
                      {{ conta.nomeFantasia }}
                    </span>
                    <small class="text-muted">{{ conta.apelido }}</small>
                  </b-form-radio>
                </div>

                <div class="d-flex align-content-around mt-5">
                  <button
                    class="btn px-4 btn-secondary mr-auto"
                    type="button"
                    @click="Voltar()"
                  >
                    Voltar
                  </button>
                  <button
                    class="btn px-4 btn-primary"
                    type="submit"
                    :disabled="!contaId"
                  >
                    Entrar
                  </button>
                </div>
              </form>
              <form v-else key="form-credenciais" @submit="onFormValidate">
                <h1>Login</h1>
                <p class="text-muted">Efetue o login.</p>
                <div class="d-flex flex-column">
                  <div class="input-group mb-3">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <CIcon name="cil-user" />
                      </span>
                    </div>
                    <input
                      v-model="email"
                      type="text"
                      class="form-control"
                      placeholder="Usuário"
                      required
                    />
                  </div>

                  <div class="input-group mb-3">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <CIcon name="cil-lock-locked" />
                      </span>
                    </div>
                    <input
                      v-model="senha"
                      type="password"
                      class="form-control"
                      placeholder="Senha"
                      required
                    />
                  </div>
                  <div
                    v-if="mensagem"
                    class="alert alert-warning alert-dismissible fade show"
                    role="alert"
                  >
                    <strong>{{ mensagem }}</strong>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                      @click="Fechar()"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>

                <div class="d-flex align-content-around mt-5">
                  <!-- <button class="btn px-4 btn-primary mr-auto" type="submit">Login</button> -->
                  <button class="btn px-4 btn-primary mr-auto" type="submit">
                    Login
                  </button>

                  <button
                    class="btn px-0 btn-link"
                    type="button"
                    @click="$router.push('/esqueci-senha')"
                  >
                    Esqueceu a Senha?
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            class="card text-center py-5 d-md-down-none bg-primary text-white"
          >
            <h2 class="m-2">Ainda não tem uma conta?</h2>
            <p class="m-5">
              Entre em contato com nossa equipe de vendas para maiores
              informações.
            </p>
            <div>
              <a
                href="https://arboran.com.br"
                target="_blank"
                class="btn btn-primary active mt-3"
              >
                Contratar agora!
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import LoginServico from "../../servico/LoginServico";
import UsuarioServico from "../../servico/UsuarioServico";

export default {
  name: "Login",
  components: { RotateSquare },
  data() {
    return {
      loading: false,
      step: "credenciais",
      email: "",
      senha: "",
      contas: [],
      contaId: "",
      mensagem: ""
    };
  },
  computed: {
    ViewModel() {
      return {
        Email: this.email,
        Senha: this.senha,
        ContaId: this.contaId || this.$store.getters.emptyGuid
      };
    }
  },
  mounted() {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push("/");
    }
  },
  methods: {
    onFormValidate(evt) {
      evt.preventDefault();

      this.ResolverContas();
    },
    onContaValidate(evt) {
      evt.preventDefault();

      this.Login();
    },
    Fechar() {
      this.mensagem = "";
    },
    Voltar() {
      this.step = "credenciais";
      this.contas = [];
      this.contaId = "";
    },
    ResolverContas() {
      this.loading = true;

      UsuarioServico.ObterContasPorEmail(this.email)
        .then((resp) => {
          const contas = resp.data || [];

          if (contas.length > 1) {
            this.contas = contas;
            this.contaId = contas[0].id;
            this.step = "conta";
            this.loading = false;
            return;
          }

          this.contaId = contas.length === 1 ? contas[0].id : "";
          this.Login();
        })
        .catch((erro) => {
          console.error("Erro ao obter contas:", erro);
          this.contaId = "";
          this.Login();
        });
    },
    Login() {
      this.loading = true;

      LoginServico.Autenticar(this.ViewModel)
        .then((resp) => {
          this.loading = false;
          // Add the following line:
          this.$http.defaults.headers.common["Authorization"] =
            "bearer " + resp.data.token;
          this.$store
            .dispatch("login", resp.data)
            .then(() => this.$router.push("/"));
        })
        .catch((erro) => {
          this.loading = false;
          console.error("Erro Login:", erro);
          this.$notify({
            data: (erro.response &&
              erro.response.data &&
              erro.response.data.erros) || [
              "Não foi possível conectar ao servidor. Tente novamente."
            ],
            type: "warn",
            duration: 5000
          });
          localStorage.removeItem("user-token");
        });
    }
  }
};
</script>
